<template>
  <a-top-brokers-with-delayed-refresh
    class="sidebar__top-brokers"
    sidebar-layout
  />
</template>

<script>
import ATopBrokersWithDelayedRefresh from '@/components/_shared/ATopBrokersWithDelayedRefresh/index.vue'

export default {
  name: 'SidebarTopBrokers',
  components: { ATopBrokersWithDelayedRefresh }
}
</script>

<style lang="scss" scoped>
.sidebar__top-brokers {
  margin-top: 20px;
}
</style>
